export const isValidCVU = (number) => number?.startsWith("000");

export const CREDIN_ACTIVITY = "credin.sentRequest.send";
export const CREDIN_CVU_ACTIVITY = "credinCVU.sentRequest.send";

export const getCredinActivityId = (recipients, isCvuSignatureEnabled = true) => {
    const isCvuOnly =
        Array.isArray(recipients) && recipients.length > 0 && recipients.every(({ cbu }) => isValidCVU(cbu));
    return isCvuOnly && isCvuSignatureEnabled ? CREDIN_CVU_ACTIVITY : CREDIN_ACTIVITY;
};

export const shouldUpdateCredinDraftActivity = (draftActivityId, requiredActivityId) =>
    Boolean(draftActivityId) && draftActivityId !== requiredActivityId;

export const isMixedCredinRecipients = (recipients) => {
    if (!Array.isArray(recipients) || recipients.length < 2) {
        return false;
    }

    const hasCvuRecipient = recipients.some(({ cbu }) => isValidCVU(cbu));
    const hasCbuRecipient = recipients.some(({ cbu }) => !isValidCVU(cbu));
    return hasCvuRecipient && hasCbuRecipient;
};

export const shouldDeleteIncompatibleCredinDraft = (draftActivityId, requiredActivityId, recipients) =>
    Array.isArray(recipients) &&
    recipients.length > 0 &&
    !isMixedCredinRecipients(recipients) &&
    shouldUpdateCredinDraftActivity(draftActivityId, requiredActivityId);

export function getCredinCvuTransactionId(id, cbuRecipients) {
    return Array.isArray(cbuRecipients) && cbuRecipients.length > 0 ? null : id;
}

export function getCredinCvuRequestData(credin, cbuRecipients) {
    const requestData = { ...credin };
    if (Array.isArray(cbuRecipients) && cbuRecipients.length > 0) {
        delete requestData.idTransaction;
    }
    return requestData;
}

const withoutTransactionId = ({ idTransaction, ...requestData } = {}) => requestData;

export const assignCredinDraftIdsForSplit = (credinCBU, credinCVU, draftActivityId) => ({
    credinCBU: draftActivityId === CREDIN_ACTIVITY ? { ...credinCBU } : withoutTransactionId(credinCBU),
    credinCVU: draftActivityId === CREDIN_CVU_ACTIVITY ? { ...credinCVU } : withoutTransactionId(credinCVU),
});

export const calculateTotalAmountCbuList = (cbuList) =>
    cbuList.reduce(
        (newElem, elem) => ({
            currency: elem.amount.currency,
            quantity: newElem.quantity + elem.amount.quantity,
        }),
        {
            currency: null,
            quantity: 0,
        },
    );

export const separarCbuList = (cbuList) => {
    const cbuListCVU = [];
    const cbuListCBU = [];

    cbuList.forEach((cbuObject) => {
        if (isValidCVU(cbuObject?.cbu)) {
            cbuListCVU.push(cbuObject);
        } else {
            cbuListCBU.push(cbuObject);
        }
    });

    return { cbuListCVU, cbuListCBU };
};

export const separarCredinAndCbuList = (credin, cbuList) => {
    const { cbuListCVU, cbuListCBU } = separarCbuList(cbuList);

    const credinCVU = {
        ...credin,
        amount: {
            currency: credin.amount.currency,
            quantity: cbuListCVU.reduce((sum, cbuObject) => sum + cbuObject?.amount?.quantity, 0),
        },
    };

    const credinCBU = {
        ...credin,
        amount: {
            currency: credin.amount.currency,
            quantity: cbuListCBU.reduce((sum, cbuObject) => sum + cbuObject?.amount?.quantity, 0),
        },
    };

    // Eliminar los amounts no necesarios
    Object.keys(credinCVU).forEach((key) => {
        if (key !== "amount" && key.startsWith("amount")) {
            delete credinCVU[key];
        }
    });
    Object.keys(credinCBU).forEach((key) => {
        if (key !== "amount" && key.startsWith("amount")) {
            delete credinCBU[key];
        }
    });

    return { credinCVU, credinCBU, cbuListCVU, cbuListCBU };
};

export const separarRecipients = (recipients) => {
    const recipientsCVU = [];
    const recipientsCBU = [];

    recipients.forEach((recipient) => {
        if (isValidCVU(recipient?.cbu)) {
            recipientsCVU.push(recipient);
        } else {
            recipientsCBU.push(recipient);
        }
    });

    return { recipientsCVU, recipientsCBU };
};
